import { useQuery } from 'react-query';
import { useContext } from 'react';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { sms_api } from '@axo/shared/data-access/api';
import { queryFunction } from '../../query-function.ts';
import {
  orttoCommunicationKeys,
  parseOrttoCommunicationKey,
} from '../../cache-keys/orttoCommunicationKeys.tsx';

export function useOrttoSMS(
  customerID: string | undefined,
  marketCountry: string | undefined
) {
  const { state } = useContext(DataAccessContext);
  const api = useAPI();
  const cacheKey = orttoCommunicationKeys.sms({
    customerID,
    marketCountry,
  });

  return useQuery(
    cacheKey,
    queryFunction(sms_api.findOrttoSMSs(api), ({ queryKey }) =>
      parseOrttoCommunicationKey(queryKey)
    ),
    {
      enabled:
        state.user.token.length > 0 &&
        customerID !== undefined &&
        marketCountry !== undefined,
    }
  );
}
